import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import style from './style.vue';
import addCoupons from './addCoupons';
import realtionProductList from './relationProduct';
import { IPSService } from '@/services/ipsServices';
import { noop } from '@/util';
import { appEnvConfig } from '@/configs/appConfigs';

export enum COUPONS_TYPE {
  ZHEKOU, // 0折扣券
  JINE, // 1金额券
  LIPIN, // 2礼品券
  DINGJIA, // 3定价券
  BAOYOU, // 4包邮券
  TONGYONG = 6, // 6通用券
  WAIBU, // 7外部券
}

export const COUPONS_TYPE_LIST = [
  { type: COUPONS_TYPE.ZHEKOU, text: '折扣券' },
  { type: COUPONS_TYPE.JINE, text: '金额券' },
  { type: COUPONS_TYPE.LIPIN, text: '礼品券' },
  { type: COUPONS_TYPE.DINGJIA, text: '定价券' },
  { type: COUPONS_TYPE.BAOYOU, text: '包邮券' },
  { type: COUPONS_TYPE.TONGYONG, text: '通用券' },
  { type: COUPONS_TYPE.WAIBU, text: '外部券' },
];

export const typeList = {
  [COUPONS_TYPE.ZHEKOU]: '折扣券',
  [COUPONS_TYPE.JINE]: '金额券',
  [COUPONS_TYPE.LIPIN]: '礼品券',
  [COUPONS_TYPE.DINGJIA]: '定价券',
  [COUPONS_TYPE.BAOYOU]: '包邮券',
  [COUPONS_TYPE.TONGYONG]: '通用券',
  [COUPONS_TYPE.WAIBU]: '外部券',
};

@Component({
  mixins: [style],
})
export default class CouponsList extends Vue {
  /**
   * 状态 9 全部 1 上架中 0 已下架
   * @type {number}
   */
  @Prop({})
    openState: number;

  @Prop()
    propKeyword: string;

  @Prop()
    propPage: number;

  @Prop()
    propPageSize: number;

  @Prop()
    propSort: number;

  @Prop()
    siteId: number;

  /**
   * 优惠券列表
   * @type {ItemArray}
   */
  public dataList: ItemArray = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 每页显示数量
   * @type {number}
   */
  public pageSize = 1;

  /**
   * 总数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {number}
   */
  public keywords = '';

  /**
   * 列表选中项Id
   * @type {Array<number>}
   */
  public tableSelected: number[] = [];

  /**
   * 加载状态
   * @type {boolean}
   */
  loadingState = false;

  /**
   * 升序/降序
   * @type {number}
   */
  public order = 0;

  @Watch('openState', { immediate: true, deep: true })
  watchState(n, o) {
    if (o) {
      // @ts-expect-error
      this.$refs.cTable.clearSort();
    }
    this.order = this.propSort;
    this.page = this.propPage;
    this.pageSize = this.propPageSize;
    this.keywords = this.propKeyword;
    this.getData();
  }

  // 监听排序变化 上传至父组件
  @Watch('order', { deep: true })
  sortWatch(n) {
    this.$emit('sortChange', n);
  }

  // 监听页码变化 上传至父组件
  @Watch('page', { deep: true })
  pagetWatch(n) {
    this.$emit('pageChange', n);
  }

  // 监听每页显示数量变化 上传至父组件
  @Watch('pageSize', { deep: true })
  pageSizeWatch(n) {
    this.$emit('pageSizeChange', n);
  }

  // 监听关键字变化 上传至父组件
  @Watch('keywords', { deep: true })
  keywordWatch(n) {
    this.$emit('keywordsChange', n);
  }

  /**
   * 获取优惠券列表
   * @param {}
   * @returns null
   */
  getData(): void {
    const postParams = {
      siteId: this.siteId,
      keyword: this.keywords,
      page: this.page,
      pageSize: this.pageSize,
      openState: this.openState,
      order: this.order,
    };
    IPSService.siteCouponList({
      postParams,
    }).then((response) => {
      this.dataList = response.list;
      this.totalCount = response.count;
    });
  }

  /**
   *
   * 添加优惠券
   * @param {}
   * @returns null
   */
  addCoupons(gsciId = 0) {
    const sgId = +this.$route.params.sgId || +this.$route.params.id;
    addCoupons.open({ siteCode: this.$route.params.code, siteId: this.siteId, gsciId, sgId }).then((result) => {
      this.getData();
    }, noop);
  }

  /**
   * 切换页码
   * @param {number} val
   */
  onPageChange(val: number): void {
    this.page = val;
    this.tableSelected = [];
    this.getData();
  }

  /**
   * 切换每页显示数量
   * @param {number} val
   */
  onPageSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.tableSelected = [];
    this.getData();
  }

  /**
   * 搜索
   * @param {}
   * @returns {}
   */
  onSearch(): void {
    this.page = 1;
    this.tableSelected = [];
    this.getData();
  }

  /**
   * 单个删除
   * @param {number} gsciId
   * @param {string} cName
   * @returns {}
   */
  onDel(gsciId: number, cName: string): void {
    this.$confirm(`确定删除${cName}`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.delCoupon([gsciId]);
      }
    }, noop);
  }

  delCoupon(gsciIds: number[]) {
    IPSService.siteCouponDelete({
      postParams: {
        gsciIds,
        siteId: this.siteId,
      },
    }).then((resposne) => {
      gsciIds.length === this.dataList.length && (this.page = 1);
      this.getData();
    });
  }

  /**
   * 批量删除
   * @param {}
   * @returns {}
   */
  onBatchDel(): void {
    if (!this.tableSelected || !this.tableSelected.length) {
      return;
    }
    this.$confirm(`确定删除选中的${this.tableSelected.length}张优惠券`, { type: 'warning' }).then((result) => {
      this.delCoupon(this.tableSelected);
    }, noop);
  }

  /**
   * 列表项选中
   * @param {ItemArray} val
   * @return {}
   */
  onSelected(val: ItemArray): void {
    this.tableSelected = (val || []).map(v => v.gsciId);
  }

  /**
   * 点击排序
   * @param column 点击列的信息
   */
  onSortChange(column) {
    switch (column.prop) {
      case 'receiveNum':
        this.order = column.order === 'ascending' ? 1 : 2;
        break;
      case 'relationNum':
        this.order = column.order === 'ascending' ? 3 : 4;
        break;
      default:
        break;
    }
    this.getData();
  }

  /**
   * 打开关联商品弹窗列表
   * @param {number} gsciId
   * @returns null
   */
  openRelationPro(gsciId: number): void {
    realtionProductList
      .open({
        gsciId,
        siteId: this.siteId,
        sendToId: appEnvConfig.NODE_ENV + this.$store.state.empCode + Date.now(),
      })
      .then((result) => {
        this.getData();
      }, noop);
  }

  /**
   * 编辑
   * @param gsciId
   */
  onEdit(gsciId) {
    this.addCoupons(gsciId);
  }

  /**
   * 修改状态
   * @param gsciId
   * @param openState
   */
  updateState(gsciId: number, openState: number) {
    openState ? this.onEnable(gsciId, openState) : this.onDisabled(gsciId, openState);
  }

  /**
   * 下架
   * @param gsciId
   * @param openState
   */
  onDisabled(gsciId: number, openState: number) {
    this.$confirm('确定下架该优惠券?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.updateCouponState([gsciId], openState);
      }
    }, noop);
  }

  /**
   * 批量下架
   */
  onBatchDisabled() {
    this.$confirm(`确定下架选中的${this.tableSelected.length}张优惠券?`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.updateCouponState(this.tableSelected, 0);
      }
    }, noop);
  }

  /**
   * 批量上架
   */
  onBatchEnable() {
    this.$confirm(`确定上架选中的${this.tableSelected.length}张优惠券?`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.updateCouponState(this.tableSelected, 1);
      }
    }, noop);
  }

  /**
   * 上架
   * @param gsciId
   * @param openState
   */
  onEnable(gsciId: number, openState: number) {
    this.updateCouponState([gsciId], openState);
  }

  /**
   * 禁/启用优惠券
   * @param gsciIds
   * @param openState
   */
  updateCouponState(gsciIds: number[], openState: number) {
    IPSService.siteCouponUpdateState({
      postParams: {
        gsciIds,
        openState,
        siteId: this.siteId,
      },
    }).then((response) => {
      gsciIds.length === this.dataList.length && (this.page = 1);
      this.getData();
    });
  }

  /**
   * 可选可不选
   * @param val
   * @param index
   */
  selectAble(val, index) {
    return this.openState === 9 ? val.openState === 1 : true;
  }

  /**
   * 刷新商品
   * @param gsciId
   */
  onRefresh(gsciId) {
    this.$confirm('确定刷新当前券的关联商品？可通过刷新重新标记关联商品数量。', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.siteCouponUpdateProduct({
          postParams: {
            siteId: this.siteId,
            gsciId,
          },
        }).then((response) => {
          this.$message.success('刷新成功');
          this.getData();
        });
      }
    });
  }

  /**
   *
   * @param h
   * @param val
   */
  renderTableBtn(h, val) {
    const { openState, gsciId, cplName } = val;
    return (
      <div>
        <span class="scopeSpan" onClick={this.onEdit.bind(this, gsciId)}>
          编辑
        </span>
        <span class="scopeSpan" onClick={this.updateState.bind(this, gsciId, openState === 0 ? 1 : 0)}>
          {openState === 0 ? '上架' : '下架'}
        </span>
        {openState === 0 && (
          <span class="scopeSpan" onClick={this.onDel.bind(this, gsciId, cplName)}>
            删除
          </span>
        )}
      </div>
    );
  }

  /**
   * 批量刷新上架券关联商品
   */
  freshAll() {
    this.$confirm('确定要刷新所有已上架券的关联商品吗？', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.siteCouponOpenUpdate({
          postParams: {
            siteId: this.siteId,
          },
        }).then((response) => {
          this.$message.success('刷新成功');
          this.getData();
        });
      }
    });
  }

  render(h) {
    return (
      <div class="p-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keywords} placeholder="券型/券名称" />
            <i class="iconfont iconsousuo" onClick={this.onSearch.bind(this)} />
          </div>
          <div class="inputWrapper">
            <el-button type="primary" onClick={() => this.addCoupons()}>
              添加券
            </el-button>
            <el-button type="primary" onClick={() => this.freshAll()}>
              批量刷新上架券关联商品{' '}
              <el-tooltip
                class="item"
                effect="light"
                content={'当券的规则发生变化，或者新上下架商品后，可点击该按钮进行所有上架券关联商品的重新标记。该操作可能持续较长时间，如果明确知道关联券，建议通过点击该券【关联商品】数字后的刷新按钮进行刷新'}
                placement="top">
                {' '}
                <i class="iconfont iconzhushi1" />{' '}
              </el-tooltip>
            </el-button>
          </div>
        </div>
        <div class="tableWrapper" style="width: 100%">
          <el-table ref="cTable" data={this.dataList} v-loading={this.loadingState} height={'calc(100% - 51px)'} on-sort-change={this.onSortChange.bind(this)} on-selection-change={this.onSelected} element-loading-text="加载中" tooltip-effect="light">
            <el-table-column type="selection" width="55px" align="center" fixed="left" show-overflow-tooltip={true} selectable={this.selectAble} />
            <el-table-column type="index" label="#" width="55" align="left" fixed="left" show-overflow-tooltip={true} />
            <el-table-column prop="cplId" label="券型编号" align="left" width="120" fixed="left" show-overflow-tooltip={true} />
            <el-table-column prop="cplName" label="券名称" align="center" width="240" show-overflow-tooltip={true} />
            <el-table-column
              prop="cplType"
              label="券类型"
              align="center"
              width="100"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scoped) => {
                    return <span>{typeList[scoped.row.cplType]}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop=""
              label="发放周期"
              align="left"
              width="300"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    const isLong = scope.row.pushEndTime === 2114352000;
                    return (
                      <span>
                        <span>{isLong ? '永久' : `${moment(scope.row.pushBeginTime * 1000).format('YYYY-MM-DD HH:mm')}至${moment(scope.row.pushEndTime * 1000).format('YYYY-MM-DD HH:mm')}`}</span>
                        &nbsp;
                        {!!scope.row.isOverTime && (
                          <el-tooltip class="item" effect="light" content={'本券已不可发放，请及时下架'} placement="top">
                            <i class="iconfont iconzhushi1" style="color: red" />
                          </el-tooltip>
                        )}
                      </span>
                    );
                  },
                },
              }}
            />
            <el-table-column prop="receiveNum" label="已领取" align="center" width="100" sortable show-overflow-tooltip={true} />
            <el-table-column
              prop="relationNum"
              label="关联商品"
              align="center"
              width="100"
              sortable
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <span>
                        {scope.row.isWorking ? (
                          <span>
                            <span class="scopeSpan q-link" onClick={this.openRelationPro.bind(this, scope.row.gsciId)}>
                              {scope.row.relationNum}&nbsp;
                            </span>
                            <i class="el-icon-refresh-right font-size-20 relative-position cursor-pointer text-blue-15" style="top: 2px;" onClick={() => this.onRefresh(scope.row.gsciId)} />
                          </span>
                        ) : (
                          <span>打标中</span>
                        )}
                      </span>
                    );
                  },
                },
              }}
            />
            <el-table-column
              prop="openState"
              label="券状态"
              align="center"
              width="100"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>{['已下架', '上架中'][scope.row.openState] || '/'}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop="updateTime"
              label="更新时间"
              align="left"
              width="140"
              show-overflow-tooltip={true}
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return <span>{moment(scope.row.updateTime * 1000).format('YYYY-MM-DD HH:mm')}</span>;
                  },
                },
              }}
            />
            <el-table-column
              prop=""
              label="操作"
              align="center"
              width="180"
              fixed="right"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return this.renderTableBtn(h, scope.row);
                  },
                },
              }}
            />
          </el-table>
          <div class="bottomWrapper">
            {this.openState == 1 && (
              <el-button type="primary" onClick={this.onBatchDisabled.bind(this)} disabled={!this.tableSelected || !this.tableSelected.length}>
                下架
              </el-button>
            )}
            {this.openState == 0 && (
              <el-button type="primary" onClick={this.onBatchEnable.bind(this)} disabled={!this.tableSelected || !this.tableSelected.length}>
                上架
              </el-button>
            )}
            {this.openState == 0 && (
              <span class={['scopeSpan', !this.tableSelected || (!this.tableSelected.length && 'disabled')]} onClick={this.onBatchDel.bind(this)}>
                删除
              </span>
            )}
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 30, 60, 100]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}
            />
          </div>
        </div>
      </div>
    );
  }
}
